import { useSpaceAccess } from '../../nucleus/access';

// A member sees an admin's acts on plugins greyed, each with the one same why.
export function usePluginsGate() {
    const access = useSpaceAccess();
    const hint = access.onlyAdmin('change its plugins');
    return { isAdmin: access.isAdmin, hint, off: access.isAdmin ? {} : { disabled: true, hint } };
}
